import { KeycloakOptions } from 'keycloak-angular';
import { KeycloakOnLoad } from 'keycloak-js';
import { environment } from '../../environments/environment';

export const keycloakConfig: KeycloakOptions = {
  config: {
    url: environment.keycloak_url,
    realm: environment.keycloak_realm,
    clientId: environment.keycloak_client_id,
  },
  initOptions: {
    onLoad: 'login-required' as KeycloakOnLoad,
    checkLoginIframe: true,
    silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
  }
};


